import 'ngmap';
import { NgModule } from 'ng-metadata/core';

import { FacilitiesMapComponent } from './facilities-map.component';

@NgModule({
  imports: ['ngMap'],
  declarations: [
    FacilitiesMapComponent,
  ],
})
export class FacilitiesMapModule {}



// WEBPACK FOOTER //
// ./resources/assets/js/common/facilities-map/facilities-map.module.ts